import axios from 'axios';

const RESOURCE_NAME = '/ecosystem/enterprises';

export default {
    getEnterprises(data) {
        return axios.post(`${RESOURCE_NAME}/get-enterprises`, data)
    },

    getConnectedEnterprises(data) {
        return axios.post(`${RESOURCE_NAME}/get-connected-enterprises`, data)
    },

    addConnection(data) {
        return axios.post(`${RESOURCE_NAME}/add-connection`, data)
    },

    getConnectedEnterprisesList(data) {
        return axios.post(`${RESOURCE_NAME}/get-connected-enterprises-list`, data)
    },
}